import React, { useState } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import { Bars } from "react-loader-spinner";

import "./TemplatePreviewModal.css";

import {
    Viewer,
    Worker,
    SpecialZoomLevel
} from "@react-pdf-viewer/core";

import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { getFilePlugin } from "@react-pdf-viewer/get-file";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";

import { createRoot } from "react-dom/client";

const TemplatePreviewModal = (props) => {
    const [refreshGrid] = useState(false);

    const handleClose = () => props.onHide();

    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const getFilePluginInstance = getFilePlugin();
    const { DownloadButton } = getFilePluginInstance;

    const injectDownloadButton = () => {
    const rightToolbar = document.querySelector(".rpv-toolbar__right");

    if (!rightToolbar) return;

    // Prevent duplicates
    if (rightToolbar.querySelector(".custom-download-wrapper")) return;

    const wrapper = document.createElement("span");
    wrapper.className = "custom-download-wrapper";

    const rootEl = document.createElement("div");
    wrapper.appendChild(rootEl);

    rightToolbar.appendChild(wrapper);

    const root = createRoot(rootEl);
    root.render(<DownloadButton />);
};

    return (
        <Modal
            {...props}
            onHide={handleClose}
            id="template-preview-modal"
            size="lg"
            centered
            scrollable="false"
            className="template-preview-modal"
            closeButton
            keyboard={false}
        >
            <Modal.Header className="preview-modal-header" closeButton />

            <Modal.Body className="preview-modal">
                {!refreshGrid ? (
                    <>
                        {/* PDF VIEWER */}
                        <Row style={{ padding: 0, margin: 0 }}>
                            <Col md={12} style={{ padding: 0, margin: 0 }}>
                                <div className="pdf-viewer">
                                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                                        <Viewer
                                            key={props.pdfFileUrl}
                                            fileUrl={props.pdfFileUrl}
                                            scrollMode="Page"
                                            defaultScale={SpecialZoomLevel.ActualSize}
                                            plugins={[
                                                defaultLayoutPluginInstance,
                                                getFilePluginInstance
                                            ]}
                                            onDocumentLoad={injectDownloadButton}
                                        />
                                    </Worker>
                                </div>
                            </Col>
                        </Row>
                    </>
                ) : (
                    <div
                        className="flex-row-center-center"
                        style={{ marginTop: "20%" }}
                    >
                        <div
                            className="spinner flex-column-center-center"
                            style={{ fontSize: 14, fontWeight: 500 }}
                        >
                            <Bars
                                height="80"
                                width="80"
                                color="var(--theme1_primary)"
                                ariaLabel="bars-loading"
                                visible={true}
                            />
                            Loading your data
                        </div>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default TemplatePreviewModal;
